import { render, staticRenderFns } from "./CompanyExpenseModal.vue?vue&type=template&id=23715b3c&scoped=true&class=fill-height&"
import script from "./CompanyExpenseModal.vue?vue&type=script&lang=ts&"
export * from "./CompanyExpenseModal.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyExpenseModal.vue?vue&type=style&index=0&id=23715b3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23715b3c",
  null
  
)

export default component.exports